module.exports = __webpack_public_path__ + "static/media/red.3bb4df09.png";